export enum FinancialEntryPayloadTypeName {
  AggregatedSpendingPayload = "AggregatedSpendingPayload",
  TransactionRecapPayload = "TransactionRecapPayload",
  MonthlyCashflowOverviewPayload = "MonthlyCashflowOverviewPayload",
  FinancialInsightsPayload = "FinancialInsightsPayload",
}
